export const LAUNCH_DARKLY_ANONYMOUS_HASH =
  'YW5vbnltb3VzLXNoZWxs-anonymous-shell';
